import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import TuvImg from 'assets/images/pages/plans/tuv.png';
import ZamannImg from 'assets/images/pages/plans/zamann-logo.png';

import classes from './ZamannProduct.module.scss';


const ZamannProduct = () => {
    return (
        <div className={classes['wrapper']}>
            <div className='container'>
                <div className="row">
                    <div className="col-lg-8 col-12">
                        <h3>Product of Zamann Pharma Support (est. 2017)</h3>
                        <p>Auditors and trainers to Europe’s leading pharma firms.</p>
                        <div className='d-flex align-items-center justify-content-lg-start justify-content-center gap-3 mb-4'>
                            <img src={TuvImg.src} alt='TUV Logo' />
                            <div>
                                <h5>TÜV ISO 9001 </h5>
                                <span> tuvsud.com/ms-zert</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={ZamannImg.src} alt='Zamann Product' />
                            <LinkButton kind='secondary-lecture' href='https://zamann-pharma.com/'>Visit Website</LinkButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZamannProduct;